import store from '../../../store/index';
import StateHelper from '../../../helpers/state-abbreviation';
import moverHelper from '../../../helpers/mover-helper';
import mapHelper from '../../../helpers/map-helper';

import * as _ from 'lodash';

export default {
  name: 'get-client',
  created () {
  },
  mounted () {
    mapHelper._isGoogleLoaded({infobox:true}).then(val=>{
      mapHelper.refreshMap().then(val => {

      })
    })
  },
  data () {
    return {
      client_id: null,
      login :null,
      error_message:null,
      error_message_login:null,
      loading:false
    }
  },
  methods: {
    searchClient () {
      if(!this.login){
        this.error_message_login = "Please Enter valid login";
        setTimeout(()=>{
            this.error_message_login = null;
        },5000)
        return;
      }
      if (!this.client_id) { 
        this.error_message = "Please enter a valid ID";
        setTimeout(()=>{
            this.error_message = null;
        },5000)
        return; 
      }

      this.loading = true;
      this.$http.post(process.env.API_URL+ '/auth/login', { "id": this.client_id, 'login': this.login } ).then(response => {
        this.loading = false;
        if (response.status == 200  && ! response.data.error) {
            moverHelper.setUserData(response.data);
    
        if (response.data.completed_process) {
            this.$router.push('/thankyou');
          } else {
            this.next();
          }
      }
      else {
        if( response.data.error == "login"){
          this.error_message_login = "Invalid Login";
          setTimeout(()=>{
              this.error_message_login = null;
          },5000)
        }
        else{
          this.error_message = "Please enter a valid ID";
          setTimeout(()=>{
              this.error_message = null;
          },5000)
        }
      }
      }).catch(error => {
        this.loading = false;
        console.log(error)
        if(error.status == 401 || error.status == 403 ){
          this.error_message = "Please enter a valid ID";
          setTimeout(()=>{
              this.error_message = null;
          },5000)
        }
        else{
          this.error_message = "Please enter a valid ID";
          setTimeout(()=>{
              this.error_message = null;
          },5000)
        }
      }) 
    },
      
    next() {
      this.$router.push({ name: "get-state" })
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Pickup/GetClient/get-client.script.js